import { useCallback, useState } from 'react';
import { UserCreatedChallengeDialog } from './UserCreatedChallengeDialog';

export const useUserCreatedChallengeDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [challengeId, setChallengeId] = useState<string | undefined>(undefined);

  const openDialog = useCallback((id?: string) => {
    setChallengeId(id);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setChallengeId(undefined);
  }, []);

  const DialogComponent = useCallback(
    () => <UserCreatedChallengeDialog isOpen={isOpen} onClose={closeDialog} challengeId={challengeId} />,
    [isOpen, closeDialog, challengeId]
  );

  return {
    openDialog,
    closeDialog,
    isOpen,
    DialogComponent
  };
};
